import { on } from '@ember/modifier';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import type { Args as BaseArgs } from 'webapp/components/form/range/list-item-base';
import FormRangeListItemBaseComponent from 'webapp/components/form/range/list-item-base';
import ToolTipWithIconComponent from 'webapp/components/tool-tip-with-icon';

import type Granulation from 'webapp/models-custom/granulation';

interface Args extends BaseArgs {
	model: Granulation;
}

export default class FormGranulationListItemComponent extends FormRangeListItemBaseComponent<Args> {
	<template>
		<li
			class="item-ct
				{{if @isSelected 'selected'}}
				{{if @model.isDisabled 'disabled'}}
				{{this.limitationInfo.className}}"
		>
			<div class="item">
				<a class="item-title" {{on "click" this.select}}>
					{{#if @isSelected}}
						<CommonUiIconComponent
							@name="CheckboxTick"
							@size="xs"
							@class="selected-icon"
						/>
					{{/if}}
					{{@model.title}}
					{{#if this.limitationInfo.text}}
						<ToolTipWithIconComponent
							@text={{this.limitationInfo.text}}
							@maxWidth={{250}}
							@iconName={{this.limitationInfo.icon}}
							@theme={{@theme}}
						/>
					{{/if}}
				</a>
			</div>
		</li>
	</template>
}
